import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ConfiguracaoSistemaInterface } from "../../_interfaces/configuracao-sistema.interface";

@Injectable({ providedIn: "root" })
export class ConfiguracaoSistemaService {
  private _apirUrl: string;

  constructor(private http: HttpClient) {
    this._apirUrl = environment.apiUrl;
  }

  selecionarTodos() {
    return this.http.get(`${this._apirUrl}/ConfiguracaoSistema`).toPromise();
  }

  selecinarPorId(pIdConfiguracaoSistema: number) {
    return this.http.get(`${this._apirUrl}/ConfiguracaoSistema/${pIdConfiguracaoSistema}`).toPromise();
  }

  selecionarNomeSistema() {
    return this.http.get(`${this._apirUrl}/ConfiguracaoSistema/SelecionarNomeSistema`).toPromise();
  }

  adicionarConfiguracao(pObj: ConfiguracaoSistemaInterface) {
    return this.http.post(`${this._apirUrl}/ConfiguracaoSistema`, pObj).toPromise();
  }

  atualizarConfiguracao(pObj: ConfiguracaoSistemaInterface) {
    return this.http.put(`${this._apirUrl}/ConfiguracaoSistema/${pObj.idConfiguracaoSistema}`, pObj).toPromise();
  }
}
